import * as React from 'react';

import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { connect } from 'react-redux';
class ApprovalHierarchyPage extends React.Component<any, null> {
	render() {
		const { userType } = this.props;
		return (
			<div>
				<Route
					path={`/${userType}/approvalHierarchies`}
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: `/${userType}/approvalHierarchies/overview`,
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		userType: state.session.userType,
	};
};

// connect the component to Redux store
export default connect(mapStateToProps)(ApprovalHierarchyPage);
